package com.fantasytenis.shared.core.network

import io.ktor.client.*
import io.ktor.client.engine.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

/**
 * Creates a platform-specific HTTP client engine.
 * Implemented in androidMain, iosMain, and jsMain.
 */
expect fun createHttpClientEngine(): HttpClientEngine

/**
 * Creates a configured HTTP client for API calls.
 *
 * @param baseUrl The base URL for API requests
 * @param sharedPrefs SharedPrefs instance for accessing auth token
 */
fun createHttpClient(baseUrl: String, sharedPrefs: com.fantasytenis.shared.core.utils.SharedPrefs): HttpClient {
    return HttpClient(createHttpClientEngine()) {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
                encodeDefaults = true
                prettyPrint = false
            })
        }

        install(HttpTimeout) {
            requestTimeoutMillis = 60_000
            connectTimeoutMillis = 60_000
            socketTimeoutMillis = 60_000
        }

        defaultRequest {
            // Add auth header if token exists
            val token = sharedPrefs.getAccessToken()
            if (token.isNotBlank()) {
                headers.append("Authorization", "Bearer $token")
            }
            headers.append("Content-Type", "application/json")
        }
    }
}
